import { render } from "./BasicInputSearch.vue?vue&type=template&id=33cc1af4&scoped=true"
import script from "./BasicInputSearch.vue?vue&type=script&lang=js"
export * from "./BasicInputSearch.vue?vue&type=script&lang=js"

import "./BasicInputSearch.vue?vue&type=style&index=0&id=33cc1af4&scoped=scoped&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cc1af4"]])

export default __exports__